
import axios from "axios";
import {useEffect, useState} from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from "@mui/material/Typography";
import {Button, CardActions, CardMedia, Dialog, DialogActions, DialogContent, DialogTitle, Modal} from "@mui/material";
import Box from "@mui/material/Box";
import Dates from "../common/dates";
import moment from 'moment';
import _ from "lodash";


export default function(props){
    console.log(props)
    const [stocks, setStocks] = useState([]);

    const fetchStocksQueue = async ()=>{
        const industryUrl = 'https://kesyn-1302292689.cos.ap-beijing.myqcloud.com/industry.json?r=' + new Date().getTime();
        var industryRes = await axios.get(industryUrl);
        setStocks(industryRes.data.filter(c=>c["涨跌幅"] > 0 && c["主力净买额"] > 0));
    };

    useEffect(() => {
        fetchStocksQueue().then();
        // setInterval(function(){
        //     fetchStocksQueue().then();
        // }, 10000)
    }, []);

    //`https://image.sinajs.cn/newchart/daily/n/${code >= "600000"? "sh" + code: "sz" + code }.gif`
    return <>
        <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
        {stocks.map((stock) => {
            stock.code = stock["板块代码"];
            let buy = stock["主力净买额"];
            //buy算出来是多少亿，保留两位小数
            if(buy) {
                buy = Math.round(buy / 10000 * 100) / 100;
            }
            return <Card sx={{ width: 400 }} style={{marginRight:10, marginBottom: 10}}  key={stock.code}>
                <CardContent key={stock["板块代码"]}>
                    {/*<img src={`https://image.sinajs.cn/newchart/daily/n/${code >= "600000"? "sh" + code: "sz" + code }.gif`} style={{backgroundColor: 'white', width: '100%'}}/>*/}
                    <div style={{fontSize: '20px'}}>
                        {stock["板块名称"]}
                    </div>
                    <div style={{fontSize: 15, color: 'red'}}>
                        {stock["涨跌幅"]}% &nbsp;&nbsp; <br/>主力净买额:{buy}亿% &nbsp;&nbsp; <br/>龙头股名称:{stock["龙头股名称"]}
                    </div>
                </CardContent>
                <div>1d</div>
                <CardMedia
                    component="img"
                    alt="green iguana"
                    width="100%"
                    crossOrigin="anonymous"
                    style={{backgroundColor:'white'}}
                    image={`https://stocks.kesyn.workers.dev/GetPic.aspx?nid=90.${stock.code}&type=&unitWidth=-6&ef=EXTENDED_BOLL&formula=KDJ&AT=1&imageType=KXL&timespan=${Math.floor(Date.now()/1000)}`}
                />
                <div>60min</div>
                <CardMedia
                    component="img"
                    alt="green iguana"
                    width="100%"
                    crossOrigin="anonymous"
                    style={{backgroundColor:'white'}}
                    image={`https://stocks.kesyn.workers.dev/GetPic.aspx?nid=90.${stock.code}&type=M60&unitWidth=-6&ef=EXTENDED_BOLL&formula=KDJ&AT=1&imageType=KXL&timespan=${Math.floor(Date.now()/1000)}`}

                />
            </Card>
        })}
    </div>
    </>
}
